export type URLParser = URL | HTMLAnchorElement;
export interface URLParserBase {
    protocol: string;
    host: string;
    href: string;
}

export function createURLParser(href: string, base?: URLParserBase): URLParser {
    if (typeof URL === 'function' && 'href' in URL.prototype) {
        const urlParserBase = base || window.location;
        let protocol = urlParserBase.protocol;
        if (protocol.indexOf(':') == -1) {
            protocol = protocol + ':';
        }
        const hrefBase = protocol + '//' + urlParserBase.host;
        return new URL(href, hrefBase);
    } else {
        const a = document.createElement('a');
        a.href = href;
        if (base) {
            a.protocol = base.protocol;
            a.port = a.protocol === 'https:' ? '443' : '80';
            a.host = base.host;
        }

        return a;
    }
}
